import { Item } from "../../../cuckoo/analysis/network/items";
import { JoeNetworks } from "../../../../@types";
import { tcpUdp } from "./schema/tcpUdp";
import { dns } from "./schema/dns";
import { http } from "./schema/http";
import { https } from "./schema/https";
import { icmp } from "./schema/Icmp";

export const items: Record<JoeNetworks, Item> = {
  tcp: {
    title: "TCP",
    schema: tcpUdp,
    errorMsg: "No TCP requests."
  },
  udp: {
    title: "UDP",
    schema: tcpUdp,
    errorMsg: "No UDP requests."
  },
  dns: {
    title: "DNS",
    schema: dns,
    errorMsg: "No DNS requests."
  },
  http: {
    title: "HTTP",
    schema: http,
    errorMsg: "No HTTP requests."
  },
  https: {
    title: "HTTPS",
    schema: https,
    errorMsg: "No HTTPS requests."
  },
  icmp: {
    title: "ICMP",
    schema: icmp,
    errorMsg: "No ICMP requests."
  },
  ftp: {
    title: "FTP",
    schema: tcpUdp,
    errorMsg: "No FTP requests."
  },
  irc: {
    title: "IRC",
    schema: tcpUdp,
    errorMsg: "No IRC requests."
  },
  smtp: {
    title: "SMTP",
    schema: tcpUdp,
    errorMsg: "No SMTP requests."
  }
};
